import React from 'react';
import PropTypes from 'prop-types';
import ShortId from 'shortid';
import ClassNames from 'classnames';
import AutoScopeStyles from '../Utilities/Decorators/AutoScopeStylesDecorator';
import applyDecoratorsDoNotUseInNewCode from '../Utilities/Decorators/ApplyDecorators';

const getFileNameFromPath = filename => filename.split('\\').pop().split('/').pop();

class DragDropFileBrowser extends React.Component {
    constructor() {
        super();

        this.state = {
            isDragging:false,
        };

        this.inputId =  ShortId.generate();
        this.fileInput = React.createRef();
    }

    static propTypes = {
        accept: PropTypes.arrayOf(PropTypes.string),
        file: PropTypes.object,
        onFileChange: PropTypes.func.isRequired //func(file);
    }

    static defaultProps = {
        accept: []
    }

    componentDidMount () {
        document.addEventListener('dragenter', this.onBodyDragEnter);
    }

    componentWillUnmount() {
        document.removeEventListener('dragenter', this.onBodyDragEnter);
    }

    render() {
        const wrapperAttributes = {};
        if(this.props.file)
            wrapperAttributes['data-filename'] = getFileNameFromPath(this.props.file.name);

        const accept = this.props.accept.join(',');
        const fileInputAttributes = {};
        if(accept !== '')
            fileInputAttributes.accept = accept;

        return (
            <div className={ ClassNames({ dragging: this.state.isDragging }, "drag drop file browser wrapper") } {...wrapperAttributes}>
                <input className="file input" type="file" ref={ this.fileInput } id={ this.inputId } onChange={ this.onFileInputChange } {...fileInputAttributes} />
                <label htmlFor={ this.inputId }>
                    <span className="button"><i className="file icon"></i> Browse</span>
                </label>

                <div id="FullScreenDragDropZone" style={ {visibility: this.state.isDragging ? "visible" : "hidden" }} onDragEnter={ this.onDrag } onDragOver={ this.onDrag } onDragLeave= { this.onDragLeave } onDrop={ this.onDrop } ></div>
            </div>
        );
    }

    componentDidUpdate(prevProps) {
        if (prevProps.file && !this.props.file) {
            // This workaround is needed for Edge.
            // Clear the file input if the file prop has been cleared out.
            // This is because the file input maintains it's own internal state and won't let you re-select the same file.
            this.fileInput.current.value = '';
        }
    }

    onFileInputChange = event => {
        const file = event.target.files.length > 0 ? event.target.files[0] : undefined;
        this.onFileChange(file);
    }

    onFileChange(file) {
        this.props.onFileChange(file);
    }

    onBodyDragEnter = event => {
        this.setState({isDragging: true});
    }

    onDrag = event => {
        event.preventDefault();
        event.stopPropagation();
    }

    onDragLeave = event => {
        this.setState({isDragging: false});
    }

    onDrop = event => {
        event.preventDefault();
        event.stopPropagation();

        this.setState({isDragging: false});

        const files = event.dataTransfer.files;

        if(files && files.length){
            this.onFileChange(files[0]);
        }
    }
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStyles);

export default withDecorators(DragDropFileBrowser);
